import { useEffect, useRef } from "react";
import { X } from "lucide-react";
import { Html5Qrcode } from "html5-qrcode";

export default function QrScanner({ open, onScan, onClose }) {
  const ref = useRef(null);
  const scannerRef = useRef(null);
  const lastRef = useRef({ text: "", ts: 0 });

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    const id = "qr-reader-region";
    const scanner = new Html5Qrcode(id, { verbose: false });
    scannerRef.current = scanner;

    const onSuccess = (text) => {
      const now = Date.now();
      // debounce duplicate reads of the same code
      if (text === lastRef.current.text && now - lastRef.current.ts < 1500) return;
      lastRef.current = { text, ts: now };
      onScan(text);
    };

    scanner
      .start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 220, height: 220 } }, onSuccess, () => {})
      .catch((err) => {
        if (!cancelled) console.error("camera start failed", err);
      });

    return () => {
      cancelled = true;
      const s = scannerRef.current;
      if (s) {
        s.stop().then(() => s.clear()).catch(() => {});
      }
    };
  }, [open, onScan]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(5,7,12,0.85)", backdropFilter: "blur(4px)" }} data-testid="qr-scanner-modal">
      <div className="w-full max-w-md rounded-2xl border overflow-hidden" style={{ background: "#0D1017", borderColor: "var(--pk-border)" }}>
        <div className="flex items-center justify-between px-5 py-3 border-b" style={{ borderColor: "var(--pk-border)" }}>
          <h3 className="font-heading font-bold text-slate-100">Scan card QR</h3>
          <button onClick={onClose} className="text-slate-500 hover:text-slate-200" data-testid="qr-scanner-close"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-4">
          <div id="qr-reader-region" ref={ref} className="w-full rounded-lg overflow-hidden" />
          <p className="text-xs text-slate-500 mt-3 text-center">Point your camera at the sticker on the back of a toploader.</p>
        </div>
      </div>
    </div>
  );
}
